import ReactEcharts from 'echarts-for-react';
import { useEffect, useRef, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import * as echarts from 'echarts';
import { Dispatch } from 'redux';
import { ChartControlsProps } from '../../redux/ChartPoperties/ChartControlsInterface';
import { updateTreeMapStyleOptions } from '../../redux/ChartPoperties/ChartControlsActions';
import { ColorSchemes } from '../ChartOptions/Color/ColorScheme';
import {
  ChartsMapStateToProps,
  ChartsReduxStateProps,
  FormatterValueProps,
} from './ChartsCommonInterfaces';
import Logger from '../../Logger';
import { formatChartLabelValueForSelectedMeasure } from '../ChartOptions/Format/NumberFormatter';
import EmptyQuery from './EmptyQuery';
import { RootState } from '../../redux';
import { tooltipStyle } from '../Common/EChartTooltip';
import {
  checkUidPresenceInCheckedMeasureForTooltip,
  limitChartData,
  shouldChartDisplayWithSecurity,
} from '../CommonFunctions/CommonFunctions';
import useCombinedColorSchemes from '../../hooks/useCombinedColorSchemes';
import { messages } from '../CommonFunctions/aliases';
import { toast } from 'react-toastify';
import { LEGEND_THRESHOLDS } from '../ChartOptions/ChartThresholds';
interface TreemapChartProps {
  updateTreeMapStyleOptions: (propKey: string, option: string, value: any) => void;
}
const Treemap = ({
  // props
  propKey,
  graphDimension,
  chartArea,
  graphTileSize,
  colorScheme,
  softUI,
  fontFamily,

  //state
  chartControls,
  chartProperties,

  //dispatch
  updateTreeMapStyleOptions,
}: ChartsReduxStateProps & TreemapChartProps) => {
  // const { tabState, selectedTab } = useSelector((state: RootState) => ({
  //   tabState: state.tabState,
  //   selectedTab: state.tabTileProps.selectedTabId,
  // }));
  // const dispatch = useDispatch();

  const { tooltipFormats, chartAxes, isTooltipEnabled, chartType, showDash } = useSelector(
    (state: RootState) => ({
      tooltipFormats: state.chartControls?.properties[propKey]?.formatOptions?.tooltipFormats,
      chartAxes: state.chartProperties.properties[propKey]?.chartAxes,
      isTooltipEnabled:
        state.chartControls?.properties[propKey]?.formatOptions?.tooltipFormats?.isEnable,
      chartType: state.chartProperties?.properties[propKey]?.chartType,
      showDash: state.tabTileProps.showDash,
    }),
  );

  const chartControl: ChartControlsProps = chartControls.properties[propKey];
  const currentControls = chartControls.properties[propKey].treeMapChartControls || {};
  const { manualColor, nodeValuesColors, allSeriesColor } = currentControls;
  let chartData: any[] = chartControl.chartData ? chartControl.chartData : [];
  const [sourceData, setsourceData] = useState<any>([]);
  const chartRef = useRef<any>(null);
  const limitedChartData = limitChartData(chartData, 5000, chartAxes[3]?.fields[0]?.displayname);

  const processedChartData = limitedChartData.map((item) => {
    return Object.fromEntries(
      Object.entries(item).map(([key, value]) => [
        key,
        value === null
          ? '(Blank)'
          : typeof value === 'boolean'
            ? value
              ? 'True'
              : 'False'
            : value,
      ]),
    );
  });

  var dimensionsKeys: string[] | any = [];
  var measure: string = '';
  const formatUtil = echarts.format;

  const getRecursiveData = ({ data, i, measure }: { data: any; i: number; measure: string }) => {
    if (i !== dimensionsKeys.length) {
      if (i === dimensionsKeys.length - 1) {
        //This will be the final level of parsing
        var childrenArray: any = [];

        var finalTotal = 0;
        data.forEach((item: any) => {
          var finalObj = {
            name: item[dimensionsKeys[i]],
            value: item[measure],
          };
          finalTotal = finalTotal + item[measure];
          childrenArray.push(finalObj);
        });

        return [childrenArray, finalTotal];
      }

      // On all other conditions
      else {
        var dimValues = data.map((dt: any) => dt[dimensionsKeys[i]]); // All values of next dimension

        var uniqueDimValues = [...new Set(dimValues)]; // Unique values of next dimension. These are the parent objects

        var formattedData: any = [];
        var total = 0;
        uniqueDimValues?.forEach((val) => {
          var parentObj = { name: val, value: 0, children: [] }; // Define parent structure (second,third,... dimension)
          var filteredData = data.filter((dt: any) => dt[dimensionsKeys[i]] === val); // Filter data only for this parent

          var [children, finalTotal]: any = getRecursiveData({
            data: filteredData,
            i: i + 1,
            measure,
          });
          parentObj.children = children;
          parentObj.value = finalTotal;
          total = total + finalTotal;
          formattedData.push(parentObj);
        });
        return [formattedData, total];
      }
    } else {
      Logger('info', 'its more than or equal to dimlenght', i);
      Logger('info', '', dimensionsKeys.length);
    }
  };

  const allThemes = useCombinedColorSchemes();
  const chartThemes = allThemes.filter((el) => {
    if (!chartControl.colorScheme || chartArea === 'dashboard') {
      return el.name === colorScheme;
    } else {
      return el.name === chartControl.colorScheme;
    }
  });
  const selectedTheme = chartThemes.length > 0 ? chartThemes[0] : allThemes[0];
  const themeColors = selectedTheme?.colors || ColorSchemes[0].colors;

  useEffect(() => {
    if (chartData.length > 5000 && !showDash) {
      toast.warning(`${messages.chart.excessiveData} 5000 records`, {
        position: 'top-center',
        autoClose: 10000,
        toastId: 'chart-data-limit-warning',
        style: {
          top: '10px',
        },
      });
    }
  }, [chartData]);

  useEffect(() => {
    if (chartData.length >= 1) {
      var formattedData: any = []; // Final data structure to feed to the map

      // columns in dimension
      dimensionsKeys = chartProperties.properties[propKey].chartAxes[1].fields.map(
        (el: any) => el.displayname,
      );

      // column in measure
      chartProperties.properties[propKey].chartAxes[2].fields.forEach((el: any) => {
        measure = el.displayname;
      });

      var dimValues = processedChartData.map((dt: any) => dt[dimensionsKeys[0]]); // All values of first dimension
      var uniqueDimValues = [...new Set(dimValues)]; // Unique values of first dimension. These are the parent objects

      if (dimensionsKeys.length === 1) {
        Logger('info', 'only one Dimenstion');
        var childrenArray: any = [];

        // --- Single Dimension Coloring ---
        processedChartData.forEach((item: any, index: number) => {
          const nameStr =
            typeof item[dimensionsKeys[0]] === 'number'
              ? JSON.stringify(item[dimensionsKeys[0]])
              : item[dimensionsKeys[0]];

          // 2. Logic Update: Handle Manual, Specific, AllSeries, and Theme fallback
          let itemColor = themeColors[index % themeColors.length];

          if (manualColor) {
            if (nodeValuesColors && nodeValuesColors[String(nameStr)]) {
              // Priority 1: Specific color for this node
              itemColor = nodeValuesColors[String(nameStr)];
            } else if (allSeriesColor) {
              // Priority 2: Global "All Series" color
              itemColor = allSeriesColor;
            }
            // Priority 3: Fallback to theme (already set above)
          }

          var finalObj = {
            name: nameStr,
            value: item[measure],
            // Apply Color
            itemStyle: {
              color: itemColor,
            },
          };
          childrenArray.push(finalObj);
        });
        setsourceData(childrenArray);
      } else if (dimensionsKeys.length > 1) {
        // For each of the parent objects, find what are their children
        uniqueDimValues.forEach((val, index) => {
          // --- Multi Dimension Coloring (Top Level) ---
          // 3. Logic Update: Handle Manual, Specific, AllSeries, and Theme fallback
          let itemColor = themeColors[index % themeColors.length];

          if (manualColor) {
            if (nodeValuesColors && nodeValuesColors[String(val)]) {
              // Priority 1: Specific color
              itemColor = nodeValuesColors[String(val)];
            } else if (allSeriesColor) {
              // Priority 2: Global "All Series" color
              itemColor = allSeriesColor;
            }
          }

          var parentObj = {
            name: val,
            value: 0,
            children: [],
            // Apply Color to Parent
            itemStyle: {
              color: itemColor,
            },
          };

          var filteredData = processedChartData.filter((dt: any) => {
            return dt[dimensionsKeys[0]] === val;
          }); // Filter data only for this parent
          var [children, total]: any = getRecursiveData({
            data: filteredData,
            i: 1,
            measure,
          });
          parentObj.children = children;
          parentObj.value = total;
          formattedData.push(parentObj);
        });
        setsourceData(formattedData);
      }
    }
    // 4. Update Dependency Array
  }, [chartData, chartControl, manualColor, nodeValuesColors, allSeriesColor, themeColors]);

  function getTooltipData(treePath: any, value: any, info: any) {
    const dimsLength = chartProperties.properties[propKey].chartAxes[1].fields.map(
      (el: any) => el.displayname,
    );
    // => {
    // return el.fieldname;

    // });

    if (dimsLength.length === parseInt(treePath.length)) {
      return [
        '<div class="tooltip-title">' + formatUtil.encodeHTML(treePath.join('>')) + '</div>',
        `${chartProperties.properties[propKey].chartAxes[2].fields[0].displayname} ` +
          formatUtil.addCommas(value),
      ].join('');
    } else {
      return `${info.data.name}`;
    }
  }

  const getSourceData = () => {
    return sourceData;
  };

  // commented for now as breadcrumb triggering a rerender
  // const [hoveredColumns, setHoveredColumns] = useState<Record<string, any>[]>([]);

  // const findTreemapDataIndexByName = (
  //   treeData: any[],
  //   targetName: string,
  //   indexTracker = { index: 0 },
  // ) => {
  //   for (const node of treeData) {
  //     if (String(node.name) === String(targetName)) return indexTracker.index;

  //     indexTracker.index++;

  //     if (node.children && node.children.length > 0) {
  //       const childIndex: number = findTreemapDataIndexByName(
  //         node.children,
  //         targetName,
  //         indexTracker,
  //       );
  //       if (childIndex !== -1) return childIndex;
  //     }
  //   }
  //   return -1;
  // };

  // useEffect(() => {
  //   const timeout = setTimeout(() => {
  //     if (
  //       tabState.tabs[selectedTab].hoveredPropkey &&
  //       tabState.tabs[selectedTab].hoveredPropkey === propKey
  //     ) {
  //       return;
  //     }
  //     const chartInstance = chartRef.current?.getEchartsInstance?.();
  //     if (!chartInstance || chartInstance.isDisposed?.()) return;

  //     const treemapData = sourceData;

  //     tabState.tabs[selectedTab].hoveredItems?.some((hovered: Record<string, any>) => {
  //       const targetName = hovered[Object.keys(chartData[0] || {})[0]];

  //       const dataIndex = findTreemapDataIndexByName(treemapData, targetName);

  //       if (dataIndex !== -1) {
  //         chartInstance.dispatchAction({
  //           type: 'highlight',
  //           seriesIndex: 0,
  //           dataIndex: dataIndex + 1,
  //         });
  //       }
  //     });
  //   }, 30); // slight delay helps when charts update

  //   return () => clearTimeout(timeout);
  // }, [tabState.tabs[selectedTab].hoveredItems, chartData]);

  // const hoveredRef = useRef<Record<string, any> | null>(null);

  // const handleChartReady = useCallback((chartInstance: any) => {
  //   chartRef.current = chartInstance;

  //   chartInstance.on('mouseover', (params: any) => {
  //     if (
  //       params?.treeAncestors &&
  //       params?.name &&
  //       hoveredRef.current?.[Object.keys(chartData[0] || {})[0]] !==
  //         params.treeAncestors[params.treeAncestors.length - 1].name
  //     ) {
  //       setHoveredColumns([]);
  //       const newEntry = {
  //         [Object.keys(processedChartData[0] || {})[0]]:
  //           params.treeAncestors[params.treeAncestors.length - 1].name,
  //       };
  //       hoveredRef.current = newEntry;

  //       let hovered: Record<string, any>[] = [];
  //       for (let ind = 1; ind < params.treeAncestors.length; ind++) {
  //         const newEntry = {
  //           [Object.keys(chartData[0] || {})[ind - 1]]: params.treeAncestors[ind].name,
  //         };
  //         const isDuplicate = hovered.some(
  //           (item) =>
  //             item[Object.keys(chartData[0] || {})[ind - 1]] === params.treeAncestors[ind].name,
  //         );
  //         if (!isDuplicate) {
  //           hovered.push(newEntry);
  //         }
  //       }
  //       setHoveredColumns(hovered);
  //     }
  //   });

  //   chartInstance.on('mouseout', (params: any) => {
  //     if (params?.name) {
  //       hoveredRef.current = null;
  //       setHoveredColumns([]);
  //     }
  //   });
  // }, []);

  // useEffect(() => {
  //   dispatch(updateHoveredItems(selectedTab, hoveredColumns, propKey));
  // }, [hoveredColumns]);

  const RenderChart = () => {
    return (
      <>
        <ReactEcharts
          ref={chartRef}
          // onChartReady={handleChartReady}
          opts={{ renderer: 'svg' }}
          // theme={chartControl.colorScheme}
          style={{
            padding: '5px',
            width: graphDimension.width,
            height: graphDimension.height,
            overflow: 'hidden',
            margin: 'auto',
            border: chartArea ? 'none' : graphTileSize ? 'none' : '1px solid rgb(238,238,238)',
          }}
          option={{
            color: selectedTheme?.colors || [],
            backgroundColor: selectedTheme?.background || [],
            tooltip: {
              show: isTooltipEnabled,
              useHTML: true,
              trigger: 'item',
              backgroundColor: 'white',
              borderWidth: 1,
              padding: 0,
              textStyle: {
                color: '#333',
                fontSize: 16,
              },
              appendToBody: true,
              extraCssText:
                'box-shadow: 0 2px 8px rgba(0,0,0,0.15);white-space: normal; word-break: break-word;',
              formatter: function (params: any) {
                const dimensionAxis = chartAxes[1];
                const dimensionAxisDisplayNames = dimensionAxis.fields.map(
                  (field: any) => field.displayname,
                );

                const measureAxis = chartAxes.find((axis: any) => axis.name === 'Measure');
                const measureName = measureAxis.fields[0]?.displayname;

                const dimensionValues = params.treePathInfo.slice(1).map((node: any) => node.name);
                //---- Create tooltip data using dimension axis key, values and measure axis key, values---- //
                const tooltipData: Record<string, any> = {};
                dimensionValues.forEach((value: string, idx: number) => {
                  tooltipData[dimensionAxisDisplayNames[idx]] = value;
                });

                tooltipData[measureName] = params.value;

                const tempData = tooltipData;
                //-----------remove unchecked measure or any axis value of type date ---------//
                const _data: { [key: string]: string | number } = {};
                Object.keys(tempData).forEach((key: string) => {
                  const resp = checkUidPresenceInCheckedMeasureForTooltip(
                    chartAxes,
                    key,
                    tooltipFormats?.checkedMeasure,
                  );
                  if (resp) {
                    _data[key] = tempData[key];
                  }
                });

                let mergedData = { ..._data };
                //-- send extra responses in _data so that it maps and shows all key value pairs including extra measure (if any)--//
                //----get extra response corresponding to all dimensions and create tooltip data----//
                const extraResponses = tooltipFormats.extraMeasureFieldsResponses;
                if (tooltipFormats && extraResponses.length > 0) {
                  const tooltipData = extraResponses.find((obj: any) => {
                    return dimensionAxisDisplayNames.every((dimensionKey: string) => {
                      const dimensionValue = tempData[dimensionKey as string];
                      return (
                        String(obj[dimensionKey as string]) === String(dimensionValue as string)
                      );
                    });
                  });
                  //------- Remove dimension keys from tooltipData-------//
                  let filteredFields = { ...tooltipData };
                  dimensionAxisDisplayNames.forEach((dimensionKey: string) => {
                    delete filteredFields[dimensionKey];
                  });
                  if (tooltipData) {
                    const measureKey = chartAxes.find((axis: any) => axis.name === 'Measure')
                      .fields[0].displayname;
                    const isPresent = checkUidPresenceInCheckedMeasureForTooltip(
                      chartAxes,
                      measureKey,
                      tooltipFormats?.checkedMeasure,
                    );
                    if (!isPresent) {
                      delete filteredFields[measureKey];
                    }
                    mergedData = { ...mergedData, ...filteredFields };
                  }
                }

                return tooltipStyle(
                  params.color,
                  mergedData,
                  tooltipFormats,
                  chartAxes,
                  dimensionAxisDisplayNames,
                  undefined,
                  undefined,
                  fontFamily,
                );
              },
            },
            series: [
              {
                type: 'treemap',
                left: chartControl.chartMargin.left + '%',
                right: chartControl.chartMargin.right + '%',
                top: chartControl.chartMargin.top + '%',
                bottom: chartControl.chartMargin.bottom + 5 + '%',
                width: 100 - (chartControl.chartMargin.left + chartControl.chartMargin.right) + '%',
                height:
                  100 - (chartControl.chartMargin.top + chartControl.chartMargin.bottom + 5) + '%',
                emphasis: {
                  focus: 'descendant',
                },
                blur: {
                  itemStyle: {
                    opacity: 0.7,
                  },
                },
                // label: {
                //   show: chartControl.labelOptions.showLabel,
                //   fontSize: chartControl.labelOptions.fontSize,
                //   fontFamily: fontFamily,
                //   color: chartControl.labelOptions.labelColor
                //     ? chartControl.labelOptions.labelColor
                //     : selectedTheme?.dark
                //       ? '#ffffff'
                //       : '#757474',
                //   backgroundColor: chartControl.labelOptions.labelBackground
                //     ? chartControl.labelOptions.labelBackgroundColor
                //     : 'transparent',
                //   borderRadius: chartControl.labelOptions.labelBackground ? 4 : 0,
                //   padding: chartControl.labelOptions.labelBackground ? [4, 8] : 0,
                //   position: chartControl.treeMapChartControls.labelPosition,
                //   rotate: chartControl.treeMapChartControls.labelRotate,
                //   align: chartControl.treeMapChartControls.horizondalAlign,
                //   verticalAlign: chartControl.treeMapChartControls.verticleAlign,
                //   overflow: chartControl.treeMapChartControls.overFlow,
                //   formatter: (value: FormatterValueProps) => {
                //     var formattedValue = value.value;

                //     formattedValue = formatChartLabelValueForSelectedMeasure(
                //       chartControls.properties[propKey],
                //       chartProperties.properties[propKey],
                //       formattedValue,
                //       chartProperties.properties[propKey].chartAxes[
                //         chartProperties.properties[propKey].chartAxes.findIndex(
                //           (item: any) => item.name === 'Measure',
                //         )
                //       ]?.fields[0]?.displayname
                //         ? chartProperties.properties[propKey].chartAxes[
                //             chartProperties.properties[propKey].chartAxes.findIndex(
                //               (item: any) => item.name === 'Measure',
                //             )
                //           ]?.fields[0]?.displayname
                //         : '',
                //     );

                //     return formattedValue;
                //   },
                // },
                label: {
                  show: chartControl.labelOptions.showLabel,
                  position: chartControl.treeMapChartControls.labelPosition,
                  rotate: chartControl.treeMapChartControls.labelRotate,
                  align: chartControl.treeMapChartControls.horizondalAlign,
                  verticalAlign: chartControl.treeMapChartControls.verticleAlign,
                  overflow: chartControl.treeMapChartControls.overFlow,

                  formatter: (value: FormatterValueProps) => {
                    var formattedValue = value.value;

                    formattedValue = formatChartLabelValueForSelectedMeasure(
                      chartControls.properties[propKey],
                      chartProperties.properties[propKey],
                      formattedValue,
                      chartProperties.properties[propKey].chartAxes[
                        chartProperties.properties[propKey].chartAxes.findIndex(
                          (item: any) => item.name === 'Measure',
                        )
                      ]?.fields[0]?.displayname
                        ? chartProperties.properties[propKey].chartAxes[
                            chartProperties.properties[propKey].chartAxes.findIndex(
                              (item: any) => item.name === 'Measure',
                            )
                          ]?.fields[0]?.displayname
                        : '',
                    );

                    return `{bg|${formattedValue}}`;
                  },
                  // we are using rich text to wrap the label in a background color
                  // this is done to ensure that the background color wraps the label
                  // and not the other way around
                  rich: {
                    bg: {
                      backgroundColor: chartControl.labelOptions.labelBackground
                        ? chartControl.labelOptions.labelBackgroundColor
                        : 'transparent',

                      padding: chartControl.labelOptions.labelBackground ? [2, 4] : 0,
                      borderRadius: chartControl.labelOptions.labelBackground ? 4 : 0,

                      fontSize: chartControl.labelOptions.fontSize,
                      fontFamily: fontFamily,
                      color: chartControl.labelOptions.labelColor
                        ? chartControl.labelOptions.labelColor
                        : selectedTheme?.dark
                          ? '#ffffff'
                          : '#757474',
                    },
                  },
                },
                itemStyle: {
                  borderWidth: chartControl.treeMapChartControls.borderWidth,
                  gapWidth: chartControl.treeMapChartControls.gapWidth,
                  borderColorSaturation: 1,
                  ...(softUI
                    ? {
                        shadowColor: 'rgba(0, 0, 0, 0.5)', // Shadow color
                        shadowBlur: 10, // Blur radius
                        shadowOffsetX: 3, // Horizontal shadow offset
                        shadowOffsetY: 3,
                      }
                    : {}),
                },
                breadcrumb: {
                  show:
                    Math.floor(graphDimension.height) > LEGEND_THRESHOLDS.treemap.h
                      ? chartControl.treeMapChartControls.showBreadCrumb
                      : false,
                  height: chartControl.treeMapChartControls.bcHeight,
                  emptyItemWidth: chartControl.treeMapChartControls.bcWidth,
                  itemStyle: {
                    color: chartControl.treeMapChartControls.bcColor,
                  },
                },
                leafDepth: Object.keys(processedChartData[0]).length,
                // leafDepth: chartControl.treeMapChartControls.leafDepth || 1,
                data: getSourceData(),
              },
            ],
          }}
        />
      </>
    );
  };

  const emptyQueryCondition =
    shouldChartDisplayWithSecurity(chartAxes, chartType, chartData) === false ||
    chartData.length < 1;

  return emptyQueryCondition ? (
    <EmptyQuery
      graphDimension={graphDimension}
      propKey={propKey}
      chartArea={chartArea}
      graphTileSize={graphTileSize}
      chartThemes={chartThemes}
      showEmptyQueryMessageWithSecurity={
        !shouldChartDisplayWithSecurity(chartAxes, chartType, chartData) ? true : false
      }
    />
  ) : (
    <RenderChart />
  );
};
const mapStateToProps = (state: ChartsMapStateToProps, ownProps: any) => {
  return {
    chartControls: state.chartControls,
    chartProperties: state.chartProperties,
  };
};
const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    updateTreeMapStyleOptions: (propKey: string, option: string, value: any) =>
      dispatch(updateTreeMapStyleOptions(propKey, option, value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Treemap);
